// Singleton SoundManager pour gérer les sons dans le jeu   
// N'est créé qu'une seule fois = Singleton
// Peut etre appelé dans n'importe quelle scene, le meme element est retourné.

let instance = null;
export default class SoundManager {
    constructor(){
        if(instance !== null){
            return instance
        }

        instance = this;

        // Variables pour mettre en pause/reprendre les audios
        this.videoMute = false
        this.muted = false
        this.audioPlayed = '',
        this.audioPlayer = undefined,
        this.effectPlayers = {}

        // Scene où est joué l'audio
        this.scene = undefined,
    
        // Info des audio à charger
        this.audioInfos = {
            Wrong: {files: ["assets/audios/effects/wrong.wav"], player: undefined, volume: 1},
            Good: {files: ["assets/audios/effects/good.wav"], player: undefined, volume: 1},
            
            // Button1: {files: ["assets/audios/effects/button_1.wav"], player: undefined, volume: 1},
            Button2: {files: ["assets/audios/effects/button_2.mp3"], player: undefined, volume: 1},
            Button3: {files: ["assets/audios/effects/button_3.wav"], player: undefined, volume: 1},
            Button4: {files: ["assets/audios/effects/button_4.mp3"], player: undefined, volume: 1},
            
            QuestionIn: {files: ["assets/audios/effects/question_in.mp3"], player: undefined, volume: 1},

            PaperSlideIn: {files: ["assets/audios/effects/paper_slide_in.mp3"], player: undefined, volume: 1},
            PaperSlideOut: {files: ["assets/audios/effects/paper_slide_out.mp3"], player: undefined, volume: 1},
            
            // PaperSlide1: {files: ["assets/audios/effects/paper_slide_1.wav"], player: undefined, volume: 1},
            // PaperSlide2: {files: ["assets/audios/effects/paper_slide_2.wav"], player: undefined, volume: 1},
            // PaperSlide3: {files: ["assets/audios/effects/paper_slide_3.wav"], player: undefined, volume: 1},
            PaperSlide4: {files: ["assets/audios/effects/paper_slide_4.mp3"], player: undefined, volume: 1},

            OrdiLocked: {files: ["assets/audios/effects/ordi_locked.mp3"], player: undefined, volume: 1},
            OrdiUnlocked: {files: ["assets/audios/effects/ordi_unlocked.wav"], player: undefined, volume: 1},
            OrdiClosed: {files: ["assets/audios/effects/ordi_closed.mp3"], player: undefined, volume: 1},
            Smartphone: {files: ["assets/audios/effects/smartphone.mp3"], player: undefined, volume: 1},
            PopUp: {files: ["assets/audios/effects/popup.mp3"], player: undefined, volume: 1},

            Leila: {files: ["assets/audios/effects/leila.mp3"], player: undefined, volume: 1},
            GardeTombe: {files: ["assets/audios/effects/garde_tombe.mp3"], player: undefined, volume: 1},
            RoueTourne: {files: ["assets/audios/effects/roue_tourne.mp3"], player: undefined, volume: 1},
            GoodEnding: {files: ["assets/audios/effects/good_ending.mp3"], player: undefined, volume: 1},


            VigileNo: {files: ["assets/audios/effects/vigile_no.mp3"], player: undefined, volume: 1},
            VigileYes: {files: ["assets/audios/effects/vigile_yes.mp3"], player: undefined, volume: 1},
            EmployeSieste: {files: ["assets/audios/effects/employe_sieste.mp3"], player: undefined, volume: 1},

            CafeDeManha: {files: ["assets/audios/musiques/cafe_de_manha.mp3"], player: undefined, volume: 1},
            DangerAhead: {files: ["assets/audios/musiques/danger_ahead.mp3"], player: undefined, volume: 1},
            ElectrostaticFields: {files: ["assets/audios/musiques/electrostatic_fields.mp3"], player: undefined, volume: 1},
            FridgeThief: {files: ["assets/audios/musiques/fridge_thief.mp3"], player: undefined, volume: 1},
            HourlyInterlapse: {files: ["assets/audios/musiques/hourly_interlapse.mp3"], player: undefined, volume: 1},
            ImmovableMountain: {files: ["assets/audios/musiques/immovable_mountain.mp3"], player: undefined, volume: 1},
            Intro: {files: ["assets/audios/musiques/intro.mp3"], player: undefined, volume: 1},
            MemoriesOfParis: {files: ["assets/audios/musiques/memories_of_paris.mp3"], player: undefined, volume: 1},
            PetDetective: {files: ["assets/audios/musiques/pet_detective.mp3"], player: undefined, volume: 1},
            RewardsOfRisk: {files: ["assets/audios/musiques/rewards_of_risk.mp3"], player: undefined, volume: 1},
            TokyoBoy: {files: ["assets/audios/musiques/tokyo_boy.mp3"], player: undefined, volume: 1},
            UnderTheRadar: {files: ["assets/audios/musiques/under_the_radar.mp3"], player: undefined, volume: 1},
        }
    }

    // Charge les fichiers audio (a mettre dans le load du preloader)
    loadAudios(scene){
        for (const [key, info] of Object.entries(this.audioInfos)) {
            scene.load.audio(key, info.files)
        }
    }

    // Défini la scene dans laquelle se lance les audios (généralement UI car tout le temps présente)
    setScene(scene){
        this.scene = scene
    }

    // Play an audio once, without changing musique
    playOnce(key){
        if(this.muted){
            return
        }

        // Récupère les info de l'audio
        var info = this.audioInfos[key]

        var audioPlayerEffect = this.scene.sound.add(key)
        audioPlayerEffect.play({ volume: info.volume})

        return audioPlayerEffect
    }

    playLoop(key){
        if(this.muted){
            return
        }

        // Récupère les info de l'audio
        var info = this.audioInfos[key]

        var audioPlayerEffect = this.scene.sound.add(key)
        audioPlayerEffect.play({ volume: info.volume, loop: true})
        this.effectPlayers[key] = audioPlayerEffect

        return audioPlayerEffect
    }

    playRandom(keys, randomVolume = false){
        if(this.muted){
            return
        }

        var key = keys[Math.floor(Math.random() * keys.length)];
        return this.playOnce(key)
    }

    stopLoop(key){
        if(this.effectPlayers[key]){
            this.effectPlayers[key].stop()
            delete this.effectPlayers[key]
        }
    }

    stopAllLoops(){
        for (const [key, player] of Object.entries(this.effectPlayers)) {
            player.stop()
            delete this.effectPlayers[key]
        }
    }

    // Joue le son choisi
    // Peu etre appelé dans n'importe quelle scene, si la scene où se joue l'audio à bien été défini (généralement l'UI car tout le temps présente)
    playAudio(key){
        // Si c'est la meme musique on ne fait rien
        if(this.audioPlayed == key){
            return
        }

        // On stop l'audio existant
        this.stopAudio()

        // On lance le nouvel audio
        var info = this.audioInfos[key]

        this.audioPlayed = key
        this.audioPlayer = this.scene.sound.add(key)

        this.audioPlayer.play({volume: info.volume,loop: true})

        // Si le son est muté on coupe le player
        if(this.muted){
            this.audioPlayer.pause()
        }

        return this.audioPlayer
    }

    // Stop l'audio en cours
    // Peut etre appelé dans n'importe quelle scene
    stopAudio(){
        if(this.audioPlayed != ''){
            // this.audioPlayer.stop()
            this.setAudioVolume({desiredVolume: 0, delta: 0.2, player: this.audioPlayer})
            this.audioPlayer = undefined
            this.audioPlayed = ''
        }
    }

    // Pause l'audio en cours
    // Peut etre appelé dans n'importe quelle scene
    pauseAudio(){
        if(this.muted){
            return
        }

        this.muted = true
        this.audioPlayer.pause()
    }

    // Reprend l'audio en cours
    // Peut etre appelé dans n'importe quelle scene
    resumeAudio(){
        if(!this.muted){
            return
        }

        this.muted = false

        if(this.audioPlayer != undefined && this.audioPlayed != ''){
            this.audioPlayer.resume()
        }
    }

    // Transition progressive entre 2 volumes
    setAudioVolume({desiredVolume, delta = 0.1, player = undefined}){
        if(player == undefined){
            player = this.audioPlayer
        } 
        
        if(player != undefined){
            this.currentVolume = desiredVolume
            if(desiredVolume < player.volume){
                delta = -delta
            }
            this.updateAudioVolume({desiredVolume, delta, player})
        }
    }

    // Fonction récursive de transition du volume
    updateAudioVolume({desiredVolume, delta = 0.1, player = undefined}){
        if(player == undefined){
            player = this.audioPlayer
        }
        player.volume += delta

        // On s'arrete si le volume est le meme
        if(player.volume.toFixed(1) == desiredVolume){
            player.volume = desiredVolume
            return
        }

        // On s'arrete si le volume est inférieur à ce qu'on souhaitait
        if(delta < 0 && player.volume.toFixed(1) <= desiredVolume){
            player.volume = desiredVolume
            return
        }

        // On s'arrete si le volume est supérieur à ce qu'on souhaitait
        if(delta > 0 && player.volume.toFixed(1) >= desiredVolume){
            player.volume = desiredVolume
            return
        }

        if(player.volume <= 0){
            player.stop()
            return
        }

        // On continue notre transition sinon
        this.scene.time.addEvent({
            delay: 75,
            callback:()=> {
                this.updateAudioVolume({desiredVolume, delta, player})
            }
        })
    }

    isMuted(){
        return this.muted
    }

    // -- Coupe l'audio lors d'une video
    pauseAudioFromVideo(){
        if(this.muted){
            return
        }
        
        this.videoMute = true

        this.pauseAudio()
    }

    resumeAudioFromVideo(){
        if(!this.videoMute){
            return
        }

        this.resumeAudio()
        this.videoMute = false
    }
}